export const ResetDashboard = function (vm) {
  console.log('ResetDashboard() Started ...')

  vm.$root.dashData = {
    TotalDealers: 0,
    TotalCustomers: 0,
    TotalSites: 0,
    TotalPrinters: 0,
    TotalUsers: 0,
    PrintersStatus: {
      TotalOnline: 0,
      TotalOffline: 0,
      TotalOutPaper: 0,
      TotalOutToner: 0,
      TotalError: 0
    },
    PrintersStatusPercent: {
      TotalOnline: '0%',
      TotalOffline: '0%',
      TotalOutPaper: '0%',
      TotalOutToner: '0%',
      TotalError: '0%'
    }
    // barChartData: ResetChartData(vm)
  }
  console.log('ResetDashboard() Ended')
}
/*
function ResetChartData (vm) {
  return {
    type: 'bar',
    data: {
      labels: [],
      datasets: [
        {
          label: 'Monthly Counters Read',
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)'
          ],
          borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)'
          ],
          borderWidth: 1,
          data: [0, 0, 0]
        }
      ]
    },
    options: {
      scales: {
        xAxes: [{
          stacked: true
        }],
        yAxes: [{
          stacked: true
        }]
      }
    }
  }
}
*/
export const CalculateDashboard = function (vm, db) {
  console.log('CalculateDashboard() Started ...')
  ResetDashboard(vm)
  vm.$root.isLoading = true
  /*
  let filter = {
    dealerKey: '',
    customerKey: '',
    siteKey: ''
  }
  if (vm.$root.isAdmin) {
    filter.dealerKey = 'All'
    filter.customerKey = 'All'
    filter.siteKey = 'All'
  } else if (vm.$root.isDealer) {
    filter.dealerKey = '5555555555555555' // vm.$root.user['.key']
    filter.customerKey = 'All'
    filter.siteKey = 'All'
  } else if (vm.$root.isCustomer) {
    filter.dealerKey = vm.$root.filter.dealerKey
    filter.customerKey = vm.$root.filter.customerKey
    filter.siteKey = 'All'
  }
  */

  // vm.$root.sites.count
  vm.$root.dashData.TotalDealers = vm.$root.dealers ? vm.$root.dealers.length : 0
  vm.$root.dashData.TotalCustomers = vm.$root.customers ? vm.$root.customers.length : 0
  vm.$root.dashData.TotalSites = vm.$root.sites ? vm.$root.sites.length : 0
  vm.$root.dashData.TotalPrinters = vm.$root.printers ? vm.$root.printers.length : 0
  vm.$root.dashData.TotalUsers = vm.$root.users ? vm.$root.users.length : 0

  GetTotalUsers(vm, db).then((totalUsers) => {
    console.log('GetTotalUsers Done.')
    if (totalUsers) {
      vm.$root.dashData.TotalUsers = totalUsers
    }
    GetPrinters(vm, db).then((printersData) => {
      console.log('GetPrinters Done.')
      if (printersData) {
        const pritnerKeys = Object.keys(printersData)
        vm.$root.dashData.TotalPrinters = pritnerKeys.length
        for (let i = 0; i < pritnerKeys.length; i++) {
          let pKey = pritnerKeys[i]
          let printer = printersData[pKey]
          CheckStatus(vm, printer)
        }
      }
      vm.$root.dashData.PrintersStatusPercent.TotalOnline = calcPercent(vm.$root.dashData.PrintersStatus.TotalOnline, vm.$root.dashData.TotalPrinters)
      vm.$root.dashData.PrintersStatusPercent.TotalOffline = calcPercent(vm.$root.dashData.PrintersStatus.TotalOffline, vm.$root.dashData.TotalPrinters)
      vm.$root.dashData.PrintersStatusPercent.TotalOutPaper = calcPercent(vm.$root.dashData.PrintersStatus.TotalOutPaper, vm.$root.dashData.TotalPrinters)
      vm.$root.dashData.PrintersStatusPercent.TotalOutToner = calcPercent(vm.$root.dashData.PrintersStatus.TotalOutToner, vm.$root.dashData.TotalPrinters)
      vm.$root.dashData.PrintersStatusPercent.TotalError = calcPercent(vm.$root.dashData.PrintersStatus.TotalError, vm.$root.dashData.TotalPrinters)
      let months = []
      months.push({ Month: vm.$moment().add(-2, 'months').format('MM / YYYY'), Title: vm.$moment().add(-2, 'months').format('MM / YYYY') })
      months.push({ Month: vm.$moment().add(-1, 'months').format('MM / YYYY'), Title: vm.$moment().add(-1, 'months').format('MM / YYYY') })
      months.push({ Month: vm.$moment().format('MM / YYYY'), Title: vm.$moment().format('MM / YYYY') })

      /*
      let barChartDataResult = GetMonthlyChartData(vm, months, db) // .then((barChartData) => {
      console.log('GetMonthlyChartData Done.')
      if (barChartDataResult) {
        console.log(barChartDataResult.data.labels)
        vm.$root.dashData.barChartData = barChartDataResult
        vm.$forceUpdate()
      }
      */
      GetRecentAlerts(vm, 12, db, function (alerts) {
        console.log('GetAlerts Called.')
        if (alerts) {
          console.log('GetAlerts Found.')
          alerts = alerts.slice().sort(function (a, b) {
            return a.LoggedInt > b.LoggedInt ? -1 : 1
          })
          console.log('GetAlerts Updating.')
          vm.$root.dashData.recentAlerts = alerts
          vm.$forceUpdate()
          console.log('GetAlerts Updated.')
        }
        console.log('GetAlerts Done.')
        vm.$root.isLoading = false
      })
    })
  })
  console.log('CalculateDashboard() Ended')
}

function calcPercent (a, b) {
  // console.log(a)
  // console.log(b)
  let percent = '0%'
  if (isNaN(a) || isNaN(b)) {
    // console.log(isNaN(a))
    // console.log(isNaN(b))
    percent = '0%'
  } else {
    percent = Math.round((a / b) * 100)
  }
  // console.log(percent)
  return percent + '%'
}

function GetTotalUsers (vm, db) {
  if (vm.$root.isAdmin) {
    return db.ref('Users').orderByKey().once('value').then(function (snapUsers) {
      if (snapUsers.val()) {
        const keys = Object.keys(snapUsers.val())
        return Promise.resolve(keys.length)
      }
    })
  } else {
    return db.ref('Users').orderByChild('DealerUID').equalTo(vm.$root.user['.key']).once('value').then(function (snapUsers) {
      if (snapUsers.val()) {
        const keys = Object.keys(snapUsers.val())
        return Promise.resolve(keys.length)
      }
    })
  }
}

function GetPrinters (vm, db) {
  // let printers = []
  vm.$root.printersByStatus = {
    Online: [],
    Offline: [],
    OutPaper: [],
    OutToner: [],
    Error: []
  }
  if (vm.$root.isAdmin) {
    return db.ref('Printers').once('value').then(function (snapPrinters) {
      const data = snapPrinters.val()
      return Promise.resolve(data)
    })
  } else if (vm.$root.isDealer || vm.$root.isDealerAssistance) {
    return db.ref('Printers').orderByChild('DealerKey').equalTo(vm.$root.filter.dealerKey).once('value').then(function (snapPrinters) {
      const data = snapPrinters.val()
      return Promise.resolve(data)
    })
  } else if (vm.$root.isCustomer) {
    return db.ref('Printers').orderByChild('CustomerKey').equalTo(vm.$root.filter.customerKey).once('value').then(function (snapPrinters) {
      const data = snapPrinters.val()
      return Promise.resolve(data)
    })
  }
}

function CheckStatus (vm, printer) {
  // console.log(printer)
  let status = ''
  let error = ''
  if (printer.ErrorString) {
    status = printer.ErrorString.toLowerCase()
    error = printer.Status.toLowerCase()
  } else if (printer.Status) {
    status = printer.Status.toLowerCase()
    error = printer.Status.toLowerCase()
  }
  if (status.indexOf('online') !== -1) {
    vm.$root.printersByStatus.Online.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOnline++
  } else if (status.indexOf('toner') !== -1) {
    vm.$root.printersByStatus.OutToner.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOutToner++
  } else if (status.indexOf('jam') !== -1) {
    vm.$root.printersByStatus.Error.push(printer)
    vm.$root.dashData.PrintersStatus.TotalError++
  } else if (status.indexOf('paper') !== -1) {
    vm.$root.printersByStatus.OutPaper.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOutPaper++
  } else if (status.indexOf('fail') !== -1) {
    vm.$root.printersByStatus.Error.push(printer)
    vm.$root.dashData.PrintersStatus.TotalError++
  } else if (status.indexOf('offline') !== -1 || status.indexOf('disconnect') !== -1) {
    vm.$root.printersByStatus.Offline.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOffline++
  } else if (status.indexOf('idle') !== -1) {
    vm.$root.printersByStatus.Online.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOnline++
  } else if (status.indexOf('other') !== -1) {
    if (error.indexOf('not ready') !== -1) {
      vm.$root.printersByStatus.Online.push(printer)
      vm.$root.dashData.PrintersStatus.TotalError++
    } else if (error.indexOf('ready') !== -1) {
      vm.$root.printersByStatus.Error.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOnline++
    } else if (error.indexOf('sleep') !== -1) {
      vm.$root.printersByStatus.Online.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOnline++
    } else if (error.indexOf('power') !== -1) {
      vm.$root.printersByStatus.Online.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOnline++
    } else if (error.indexOf('printing') !== -1) {
      vm.$root.printersByStatus.Online.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOnline++
    } else if (error.indexOf('disconnect') !== -1) {
      vm.$root.printersByStatus.Offline.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOffline++
    } else if (error.indexOf('size mismatch') !== -1) {
      vm.$root.printersByStatus.Error.push(printer)
      vm.$root.dashData.PrintersStatus.TotalError++
    } else if (error.indexOf('tray') !== -1) {
      vm.$root.printersByStatus.OutPaper.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOutPaper++
    } else if (error.indexOf('disconnect') !== -1) {
      vm.$root.printersByStatus.Offline.push(printer)
      vm.$root.dashData.PrintersStatus.TotalOffline++
    } else {
      vm.$root.printersByStatus.Error.push(printer)
      vm.$root.dashData.PrintersStatus.TotalError++
    }
  } else {
    vm.$root.printersByStatus.Online.push(printer)
    vm.$root.dashData.PrintersStatus.TotalOnline++
  }
}

/*
function GetMonthlyChartData (vm, months, db) {
  console.log(months)
  barChartData.data.labels = []
  barChartData.data.labels.push(months[0].Title)
  barChartData.data.labels.push(months[1].Title)
  barChartData.data.labels.push(months[2].Title)
  barChartData.data.datasets = [
    {
      label: 'Monthly Counters Read',
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 1,
      data: []
    }
  ]

  barChartData.data.datasets[0].data = [0, 0, 0]
  if (vm.$root.isAdmin) {
    getAdminMonthlyCounters(vm, months, db, function (dataArr) {
      barChartData.data.datasets[0].data = dataArr
      vm.$root.dashData.barChartData = barChartData
      return barChartData
    })
  } else if (vm.$root.isDealer) {
    getDealerMonthlyCounters(vm, months, db, function (dataArr) {
      barChartData.data.datasets[0].data = dataArr
      vm.$root.dashData.barChartData = barChartData
      return barChartData
    })
  } else if (vm.$root.isCustomer) {
    getCustomerMonthlyCounters(vm, months, db, function (dataArr) {
      barChartData.data.datasets[0].data = dataArr
      vm.$root.dashData.barChartData = barChartData
      return barChartData
    })
  } else {
    return null
  }
}
let barChartData = {
  type: 'bar',
  data: {
    labels: ['01 / 2020', '02 / 2020', '03 / 2020'],
    datasets: [
      {
        label: 'Monthly Counters Read',
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        borderColor: [
          'rgba(255,99,132,1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)'
        ],
        borderWidth: 1,
        data: [100, 200, 300]
      }
    ]
  },
  options: {
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true
      }]
    }
  }
}

function getAdminMonthlyCounters (vm, months, db, callback) {
  console.log('getAdminMonthlyCounters() ...')
  let dataArr = [0, 0, 0]
  callback(dataArr)
}

function getDealerMonthlyCounters (vm, months, db, callback) {
  console.log('getDealerMonthlyCounters() ...')
  let dataArr = [0, 0, 0]
  callback(dataArr)
}

function getCustomerMonthlyCounters (vm, months, db, callback) {
  console.log('getCustomerMonthlyCounters() ...')
  let dataArr = [0, 0, 0]
  callback(dataArr)
}
*/

function GetRecentAlerts (vm, maxRows, db, callback) {
  let alerts = []
  // let childKey = ''
  let startAtValue = ''
  let endAtValue = ''
  let fromDate = vm.$moment().add(-30, 'days').format('YYYY-MM-DD')
  let toDate = vm.$moment().add(1, 'days').format('YYYY-MM-DD')
  let fromDateInt = Number(vm.$moment(fromDate).format('YYYYMMDD') + '000000')
  let toDateInt = Number(vm.$moment(toDate).format('YYYYMMDD') + '235900')
  if (vm.$root.isAdmin) {
    db.ref('Alerts').orderByChild('LoggedInt').limitToLast(10).on('value', (snapAlerts) => {
      const data = snapAlerts.val()
      if (data) {
        console.log(data)
        const keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i]
          let item = data[key]
          item['.key'] = key
          let cust = vm.$root.customers.find(c => c.value === item.CustomerKey)
          if (cust) {
            item['CustomerName'] = cust.title
          }
          alerts.push(item)
        }
      }
      callback(alerts)
    })
  } else if (vm.$root.isDealer) {
    startAtValue = vm.$root.filter.dealerKey + '_' + fromDateInt
    endAtValue = vm.$root.filter.dealerKey + '_' + toDateInt
    db.ref('Alerts').orderByChild('DateDealerKey').startAt(startAtValue).endAt(endAtValue).limitToLast(maxRows).once('value', (snapAlerts) => {
      const data = snapAlerts.val()
      if (data) {
        console.log(data)
        const keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i]
          let item = data[key]
          item['.key'] = key
          let cust = vm.$root.customers.find(c => c.value === item.CustomerKey)
          if (cust) {
            item['CustomerName'] = cust.title
          }
          alerts.push(item)
        }
      }
      callback(alerts)
    })
  } else if (vm.$root.isCustomer) {
    startAtValue = vm.$root.filter.dealerKey + '_' + vm.$root.filter.customerKey + '_' + fromDateInt
    endAtValue = vm.$root.filter.dealerKey + '_' + vm.$root.filter.customerKey + '_' + toDateInt
    db.ref('Alerts').orderByChild('DateDealerCustomerKey').startAt(startAtValue).endAt(endAtValue).limitToLast(maxRows).once('value', (snapAlerts) => {
      const data = snapAlerts.val()
      if (data) {
        console.log(data)
        const keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i]
          let item = data[key]
          item['.key'] = key
          let cust = vm.$root.customers.find(c => c.value === item.CustomerKey)
          if (cust) {
            item['CustomerName'] = cust.title
          }
          alerts.push(item)
        }
      }
      callback(alerts)
    })
  } else {
    callback(alerts)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dashboard.js